import { firestoreFirebaseAuthApp } from '@hooks/useFireBase/useFireBase';
import { storeSetAuth, storeSetToken, storeSetUserType } from '@store/auth-reducer';
import { store } from 'rootStore';
import Cookies from 'js-cookie';

export const accessToken = 'accessToken';
export const refreshToken = 'refreshToken';

export const setItem = (key: string, value: any) => {
  window.localStorage.setItem(key, value);
};

export const getItem = (key: string) => {
  const value = window.localStorage.getItem(key);
  return value === null ? '' : value;
};

export const setToken = (value: string) => {
  Cookies.set(accessToken, value, { expires: 7 });
};

export const clearToken = () => setToken('');

export const getToken = () => {
  return Cookies.get(accessToken);
};

export const setRefreshToken = () => {
  Cookies.set(accessToken, '');
};

export const clearRefreshToken = () => setRefreshToken();

export const getRefreshToken = () => getItem(refreshToken);

export const handleLogout = (isNavigateToLogin: boolean = true) => {
  clearRefreshToken();
  Cookies.remove('isSettingSalary');
  store.dispatch(storeSetToken(''));
  store.dispatch(storeSetUserType(0));
  store.dispatch(storeSetAuth(null));
  firestoreFirebaseAuthApp?.signOut();
  setTimeout(() => {
    window.location.reload();
    if (isNavigateToLogin) (window as any).location.href = '/login';
  }, 100);
};
